module.exports = __webpack_public_path__ + "img/GAME_POND.612c4adc.png";